import React from "react";
import useSWR from "swr";
// import moment from "moment";

const fetcher = (...args) => fetch(...args).then((res) => res.json());
function Newsevent() {
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const school = process.env.REACT_APP_SCHOOL;
  const url =
    `${baseUrl}/${school}/items/notice?fields=*.*.*`;

  const { data, error } = useSWR(url, fetcher);

  if (error) {
    return <div>Error...</div>;
  }
  if (!data) {
    return <div>No data...</div>;
  }
  return (
    <div>
      <div className="eventinfo" >
        <h3 style={{
          textAlign: "center", color: '#fff',

        }}>Notice</h3>
        <hr />
        <div>
          <div className="">
            {/* <ul>
                        <li>       
                        style={{
        backgroundImage: 'linear-gradient(to right, #002a5c, #888f9c)',
              }}
                        <div className="in-image"><div className="tt-b-day rem-border">05<div className="tt-b-day-r"><div className="tt-b-month">Sep</div><div className="tt-b-date">2020</div></div></div><span className="in-turquoise"><h6>+ Read more</h6></span></div> <div className="in-content" id="nid" >Online Dance Competition (Solo) </div></li>
                        </ul> */}

       
   
             
             
                      {data.data.map((item, i) => {
                        return (
                       
                       <>
                       <div className="calender_xyz">

                        

    <p key={i}>

{item.title}

</p>
                  </div>

                       </>
   
                         
                        );
                      })}
                
                
           

              
        
          </div>
        </div>
        { /* <div>
          <button
            style={{
              margin: "10px 0px 0px 0px",
              backgroundColor: "#4c6578",
              padding: "5px",
              borderRadius: "5px",
              color: "#fff"
            }}
          >
            Read More
          </button>
        </div> */}
      </div>
    </div >
  );
}

export default Newsevent;
